/**
 * Represent the data model for a retell phone call request.
 */
export interface RetellPhoneCall {
  readonly id: string;
  readonly agentId: string;
  readonly userPhoneNumber: string;
  readonly aiServiceType: AvailedAiServiceEnum;
}

export enum AvailedAiServiceEnum {
  ACTION_PLAN = 'action_plan',
  LEAD_GENERATOR = 'lead_generator',
  APPOINTMENT_SETTER = 'appointment_setter',
  SUPPORT_AGENT = 'support_agent',
  CALL_CENTER = 'call_center',
}
